export default {
  "HitPaw Online Audio Converter": "HitPaw convertidor de audio online",
  "Convert audios to MP3, AAC, FLAC, WMA and more formats for free.": "Convertir audio a MP3, AAC, FLAC, WMA y otros formatos de forma gratuita.",
  'HitPaw Online Image Converter': 'HitPaw convertidor de imágenes online',
  'Convert images to JPG, PNG, BMP, TIFF and more formats for free.': 'Convertir imágenes a JPG, PNG, BMP, TIFF y otros formatos de forma gratuita.',
  'HitPaw Online Video Converter': 'HitPaw Convertidor de Videos Online',
  'Convert videos to any formats as your requirements.': 'Convertir videos a cualquier formato que quieras.',
  'Add More Files': 'Agregar más archivos',
  'Convert to': 'Convertir en',
  'Ready': 'Listo',
  'Converting': 'Convirtiendo',
  'Video': 'Video',
  'Audio': 'Audio',
  'Image': 'Imagen',
  'Retry': 'Reintentar',
  'Download All': 'Descargar todo',
  'Download Desktop': 'Descargar aplicación de escritorio',
  'Continue Editing': 'Continuar editando',
  'Convert': 'Convertir',
  'Cut': 'Cortar',
  'Speed': 'Velocidad',
  'Crop & Rotate': 'Recortar & Rotar',
  'Resize': 'Ajustar',
  'Extract': 'Extraer',
  'Add Music': 'Añadir música',
  'Subtitles': 'Subtítulos',
  'Merge': 'Unir',
  'Watermark Remover': 'Quitar marca de agua',
  'Add Watermark': 'Añadir marca de agua',
  'Please select a file to use': 'Selecciona un archivo para {{work}}',
  'Batch Processing': 'Procesamiento por lotes',
};
